import { colors } from '@/theme/colors';

export type ElectricCarBannerAbbreviatedProps = {
  size?: { width: number; height: number };
};

export default function ElectricCarBannerAbbreviated({
  size = { width: 52, height: 24 },
}: ElectricCarBannerAbbreviatedProps) {
  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox={`0 0 ${size.width} ${size.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="1"
        d="M0 12C0 5.37258 5.37258 0 12 0H40C46.6274 0 52 5.37258 52 12C52 18.6274 46.6274 24 40 24H12C5.37258 24 0 18.6274 0 12Z"
        fill="#E8E8E8"
      />
      <path
        opacity="0.16"
        d="M0 12C0 5.37258 5.37258 0 12 0H40C46.6274 0 52 5.37258 52 12C52 18.6274 46.6274 24 40 24H12C5.37258 24 0 18.6274 0 12Z"
        fill="url(#paint0_linear_4034_219848)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
        fill="url(#paint1_linear_4034_219848)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7224 5L8 13.2163L11.5312 13.2163L9.49391 19.1924L15.4694 10.9761H12.4305L14.7224 5Z"
        fill="white"
      />
      <path
        d="M31.6084 15.1543V17H26.3037V15.1543H31.6084ZM27.1582 7.04688V17H24.7588V7.04688H27.1582ZM30.9248 10.998V12.7822H26.3037V10.998H30.9248ZM31.6289 7.04688V8.89941H26.3037V7.04688H31.6289ZM38.8794 14.6553L40.9507 7.04688H43.6372L40.2807 17H38.5444L38.8794 14.6553ZM36.9995 7.04688L39.0708 14.6553L39.4194 17H37.6626L34.3266 7.04688H36.9995Z"
        fill="url(#paint2_linear_4034_219848)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4034_219848"
          x1="-4.66424e-08"
          y1="12"
          x2="51.9998"
          y2="11.902"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.evBlue} />
          <stop offset="0.9999" stopColor={colors.darkBlue100} stopOpacity="0.9" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_4034_219848"
          x1="-3.16742e-08"
          y1="12"
          x2="105"
          y2="12.3553"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.evBlue} />
          <stop offset="0.9999" stopColor={colors.darkBlue100} stopOpacity="0.9" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_4034_219848"
          x1="13"
          y1="10.5"
          x2="45.5"
          y2="10.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={colors.evBlue2} />
          <stop offset="1" stopColor={colors.darkBlue100} stopOpacity="0.9" />
        </linearGradient>
      </defs>
    </svg>
  );
}
